import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Products from "@/components/site/Products";
import Furniture from "@/components/site/Furniture";
import Motors from "@/components/site/Motors";
import Advantages from "@/components/site/Advantages";
import Process from "@/components/site/Process";
import FAQ from "@/components/site/FAQ";
import RequestForm from "@/components/site/RequestForm";
import Contacts from "@/components/site/Contacts";
import Footer from "@/components/site/Footer";

function App() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="App bg-white text-slate-900 font-body" data-testid="app-root">
      <Header scrolled={scrolled} />
      <main>
        <Hero />
        <About />
        <Products />
        <Furniture />
        <Motors />
        <Advantages />
        <Process />
        <FAQ />
        <RequestForm />
        <Contacts />
      </main>
      <Footer />
      <Toaster
        position="top-right"
        richColors
        closeButton
        toastOptions={{
          style: {
            fontFamily: "Manrope, sans-serif",
            borderRadius: "4px",
          },
        }}
      />
    </div>
  );
}

export default App;
